import { useState } from "react";

const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function getDateString() {
  let d = new Date();
  const day = DAY_NAMES[d.getDay()];
  const month = MONTH_NAMES[d.getMonth()];
  const date = String(d.getDate()).padStart(2, "0");

  return `${day}, ${month} ${date}`;
}

function getTime() {
  let d = new Date();
  let hours = d.getHours();
  hours = hours >= 12 ? hours - 12 : hours;
  if (hours % 12 === 0) hours = 12;
  return `${hours}:${String(d.getMinutes()).padStart(2, "0")}`;
}

function getAMPM() {
  let d = new Date();
  let hours = d.getHours();
  return hours >= 12 ? "PM" : "AM";
}

export default function Time() {
  const [time, setTime] = useState(getTime());
  const [am_pm, set_am_pm] = useState(getAMPM());
  const [date, setDate] = useState(getDateString());

  setInterval(() => {
    setTime(getTime());
    setDate(getDateString());
    set_am_pm(getAMPM());
  }, 1000);

  return (
    <div className="Container">
      <div className="Date">{date}</div>
      <div>
        <span className="Time">{time}</span>
        <span className="AM_PM">{am_pm}</span>
      </div>
    </div>
  );
}
